import { useRef, useEffect } from 'react';
import Blazy from 'blazy';

/**
 * @param {string} containerID
 * @param {Array[any]} dependencies
 * @returns {void}
 */
const useBLazyRevalidate = (containerID, dependencies = []) => {
    const bLazyRef = useRef(null);

    useEffect(() => {
        bLazyRef.current = new Blazy({
            offset: 150,
            container: `#${containerID}`
        });

        return () => {
            bLazyRef.current.destroy();
        };
    }, []);

    useEffect(() => {
        if (bLazyRef.current) {
            bLazyRef.current.revalidate();
        }
    }, [...dependencies]);
};

export default useBLazyRevalidate;
